import type { SVGProps } from 'react';
const SvgIconProfileGuests = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} {...props}>
    <path
      fill="#1A202C"
      d="M12.45 11.448h-2.9c-2.938 0-5.32 2.715-5.32 6.065 0 .609.434 1.102.968 1.102h11.604c.534 0 .967-.493.967-1.102 0-3.35-2.381-6.065-5.318-6.065zM5.712 16.96c.239-2.174 1.868-3.859 3.838-3.859h2.902c1.969 0 3.599 1.687 3.837 3.86H5.711zM11 11c2.136 0 3.868-1.705 3.868-3.808S13.136 3.385 11 3.385 7.132 5.089 7.132 7.192 8.863 11 11 11m0-6.188c1.333 0 2.418 1.068 2.418 2.38S12.333 9.572 11 9.572s-2.418-1.068-2.418-2.38S9.667 4.812 11 4.812"
    />
  </svg>
);
export default SvgIconProfileGuests;
